import { Fragment } from 'react';
import { Group, Kbd, Modal, Table, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { CALL_SHORTCUTS } from './shortcuts';

type ShortcutAction = keyof typeof CALL_SHORTCUTS | 'pushToTalk';

const SHORTCUT_ORDER: readonly ShortcutAction[] = [
    'microphone',
    'camera',
    'pushToTalk',
    'screenShare',
    'hand',
    'chat',
    'participants',
    'layout',
    'fullscreen',
    'help',
];

export function ShortcutsDialog({ opened, onClose }: Readonly<{ opened: boolean; onClose: () => void }>) {
    const { t } = useTranslation('conference');
    const { t: tCommon } = useTranslation('common');

    return (
        <Modal centered opened={opened} size="lg" title={t('shortcuts.title')} onClose={onClose}>
            <Table verticalSpacing="var(--spacing-2)">
                <Table.Tbody>
                    {SHORTCUT_ORDER.map((action) => {
                        const combos = action === 'pushToTalk' ? [[t('shortcuts.space')]] : CALL_SHORTCUTS[action];
                        return (
                            <Table.Tr key={action}>
                                <Table.Td>
                                    <Text size="sm">{t(`shortcuts.${action}`)}</Text>
                                </Table.Td>
                                <Table.Td>
                                    <Group gap="var(--spacing-2)" justify="flex-end" wrap="nowrap">
                                        {combos.map((combo, comboIndex) => (
                                            <Fragment key={combo.join('+')}>
                                                {comboIndex > 0 && (
                                                    <Text c="dimmed" component="span" size="xs">
                                                        {tCommon('shortcut.or')}
                                                    </Text>
                                                )}
                                                <Group gap="var(--spacing-1)" wrap="nowrap">
                                                    {combo.map((key, keyIndex) => (
                                                        <Fragment key={key}>
                                                            {keyIndex > 0 && (
                                                                <Text c="dimmed" component="span" size="xs">
                                                                    +
                                                                </Text>
                                                            )}
                                                            <Kbd size="sm">{key}</Kbd>
                                                        </Fragment>
                                                    ))}
                                                </Group>
                                            </Fragment>
                                        ))}
                                    </Group>
                                </Table.Td>
                            </Table.Tr>
                        );
                    })}
                </Table.Tbody>
            </Table>
        </Modal>
    );
}
